module.exports = __webpack_public_path__ + "img/empty.d2a1f87e.png";